import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {RockBottom} from "../../RockBottom";
import {TimelineLite} from "gsap";

export class MidSymLandingController extends ReelStopPresentationController {
    constructor() {
        super("MidSymLandingController");
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        if (!(RockBottom.inBonusGame)) {
            return Promise.resolve();
        }

        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<any> {
        if (!(RockBottom.inBonusGame)) {
            return Promise.resolve();
        }

        const anim: TimelineLite = new TimelineLite();
        anim.add(RockBottom.freeSpinView.onReelStopped(data.reelId));
        anim.to(this, {duration: 0.1});
        return Promise.resolve(anim);
    }
}